<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <div id="express-component" class="fill-height" v-if="skeletonReady">

            <telsasoft-dashboard v-if="expressView == 'localdashboard'" :expressViewConditions="expressViewConditions" />

        </div>


        <!-- LOADING -->
        <div id="loading-overlay">
            <v-icon id="loading-icon">fa fad-spinner-third fa-spin</v-icon>
        </div>

        <!-- CONFIRM DIALOG -->
        <confirm v-model="$store.state.confirmModal.show" />
        
    </v-container>
</template>

<script>
import Vue from 'vue';
import Confirm from '@/views/Confirm';
import TelsasoftDashboard from '@/views/TelsasoftDashboard.vue';
export default {
    name: 'ExpressRenderer',
    props: [],
    components: {
        Confirm,
        TelsasoftDashboard
    },
    data: () => ({
        expressToken: null,
        expressObject: null,
        expressView: null,
        expressViewConditions: null,
        usersList: [],
        skeletonReady: false
    }),

    computed: {

    },

    methods: {
        buildExpressModeSkeleton: function() {
            this.expressToken = (new URLSearchParams(window.location.search)).get('express');
            this.expressToken = this.expressToken.replace(/\n/g, "");
            this.expressToken = this.expressToken.replace(/\r/g, "");
            this.expressToken = this.expressToken.replace(/ /g, "");
            this.expressObject = JSON.parse(atob(this.expressToken.split('.')[1]));
            this.expressView = this.expressObject.identity.express_view;
            this.expressViewConditions = this.expressObject.identity.express_view_conditions;

            console.log('this.expressToken: ', this.expressToken);
            console.log('this.expressObject: ', this.expressObject);
            console.log('this.expressView: ', this.expressView);

            let user = {
                user_id: this.expressObject.identity.user_id,
                user_username: this.expressObject.identity.user_username,
                user_permissions: this.expressObject.identity.user_permissions
            };

            this.$store.commit('setUser', user);
            Vue.http.headers.common['Authorization'] = ('Bearer ' + this.expressToken);
            let batchConfig = this.expressObject.identity.express_batch_config;


            this.$store.dispatch('setBatchConfig', batchConfig);

            this.skeletonReady = true;




            // Get additional resources after we've set the express JWT.
            let promises = this.getExpressViewResources();
            Promise.all(promises).then(r => {
                console.log('GETTING RESOURCES DONE!');
                this.$store.commit('setExpressReady', true)
            }).catch(error => {
                console.log('ERROR: ', error);
                TELSA.loading(false);
                let title = 'Error';
                let message = 'An error has occured. Please contact <a href="mailto:support@telsasoft.com" style="color: #c42111;">support</a> with any questions.';
                if(error && error.bodyText) {
                    message += `\n${error.bodyText}`
                }
                if(error && error.status == 422) {
                    title = 'Invalid token signature';
                    message = 'Signature verification failed. Please contact <a href="mailto:support@telsasoft.com" style="color: #c42111;">support</a> with any questions.';
                }
                else if(error && error.status == 401) {
                    title = 'Token has expired';
                    message = 'This subscription link has expired and can no longer be accessed.';
                }
                this.$store.commit('showConfirmModal', {
                    title: title,
                    message: message,
                    type: 'error',
                    hideCancel: true,
                    confirmAction: () => {window.close();}
                });
            });


            
            
        },

        getExpressViewResources: function() {
            let promises = [];

            if(this.expressView == 'localdashboard') {
                promises.push(this.getUsers());
                promises.push(this.$store.dispatch('getCurrentAlarms'));
                promises.push(this.$store.dispatch('getCurrentIssues'));
            }

            return promises;
        },

        getUsers: function() {
            let route = (TELSA.apiHost + "users/list");
            TELSA.loading(true);
            console.log('GETTING RESOURCES');
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.usersList = result.users_list;
                let batchConfig = this.$store.state.batchConfig;
                batchConfig.users = this.usersList;
                this.$store.dispatch('setBatchConfig', batchConfig);
            });
        },

        buildTokenExpCheck: function() {
            const self = this;

            setInterval(function() {
                if(TELSA.isTokenExpired(self.expressToken)) {
                    self.$store.commit('showConfirmModal', {
                        title: 'Token has expired',
                        message: 'This subscription link has expired and can no longer be accessed.',
                        type: 'error',
                        hideCancel: true,
                        confirmAction: () => {window.close();}
                    });
                }
            }, 5000); // 5 Seconds
        }
    },

    created() {
        console.log('Express Renderer Created');
        
    },

    mounted() {
        console.log('Express Renderer Mounted');
        this.buildExpressModeSkeleton();
        this.buildTokenExpCheck()
    }

  
};
</script>
